import { Component, HostListener, OnDestroy, OnInit } from '@angular/core'
import { ModalService } from '../../../../../services/modal.service'
import { FormBuilder, FormGroup } from '@angular/forms'
import { ActivatedRoute } from '@angular/router'
import { AuthService } from '../../../../../services/auth.services'
import { RestServices } from '../../../../../services/rest.services'
import { SharedServices } from '../../../../../services/shared.services'
import { StateServices } from '../../../../../services/state.services'
import * as moment from 'moment'
import { isUndefined, omitBy } from 'lodash'
import { notification } from 'onsenui'
import { MatrixServices } from '../../../../../services/image/matrix.services'
import { ClientTopServices } from '../../../../../services/ClientTop.services'

@Component({
    selector: 'app-aligner-create',
    templateUrl: './aligner-create.component.html',
    styleUrls: [
        '../../../../../stagingcss/root-ui-view.component.css',
        '../../../../../stagingcss/ui-schema-table-form.component.css',
        '../../../../../stagingcss/lui-select.component.css',
        './aligner-create.component.css',
        '../../../../../stagingcss/image-viewer.component.css',
    ],
})
export class ModalAlignerCreateComponent implements OnInit, OnDestroy {

    resourceUrl = 'resource'
    modalStatus = 'hidden'
    formNewAlignerGeneral: FormGroup
    alignerMenu = [{ name: 'General', value: 'general' }, { name: 'Adjustments', value: 'adjustments' }, {
        name: 'Stages',
        value: 'stages',
    }, { name: 'Progess', value: 'progress' }]
    activeAlignerMenu = {}
    activePhase = {}
    activeAligner = {}
    phaseNumber = [{ value: 1, name: '1st' }, { value: 2, name: '2nd' }, { value: 3, name: '3rd' }, {
        value: 4,
        name: '4th',
    }, { value: 5, name: '5th' }, { value: 6, name: '6th' }]
    phaseByName = {
        'counseling': {
            value: 'counseling', name: 'Counseling',
        }, 'pre': {
            value: 'pre', name: 'Pre',
        }, 'retainer': {
            value: 'retainer', name: 'Retainer',
        }, 'followUp': {
            value: 'followUp', name: 'Follow Up',
        },
    }
    totalNumber = 0
    totalNumberCurent = 0
    langDefault = localStorage.getItem('lang') === 'false' ? 'false' : 'true'
    idClient: any
    idAligner: any
    clientAligner = {
        lastPassedAlignerCount: 0, aligners: [], flows: [], alignerTreatment: [], totalNumber: 0,
    }
    alignerTreatmentOptions = []

    originClientAligner = jQuery.extend(true, {}, this.clientAligner)
    clientDetail = {}
    activeAlignerCount = -1
    elasticConvert = {
        'red': '1/4 Heavy', 'germany': '3/16 Heavy', '18medium': '1/8 Medium',
    }
    treatmentOptions = {
        'ipr': { name: 'IPR', value: 'ipr' },
        'aton': { name: 'AtOn', value: 'aton' },
        'atout': { name: 'AtOut', value: 'atout' },
        'buttonon': { name: 'BuOn', value: 'buttonon' },
        'buttonout': { name: 'BuOut', value: 'buttonout' },
        'hookon': { name: 'HuOn', value: 'hookon' },
        'hookout': { name: 'HuOut', value: 'hookout' },
        'hookmove': { name: 'HuMove', value: 'hookmove' },
        'overcorrection': { name: 'OC', value: 'overcorrection' },
        'buttoncut': { name: 'Button Cut', value: 'buttoncut' },
        'precisioncut': { name: 'Precision', value: 'precisioncut' },
    }
    modalAction = ''
    // doctorList = [];
    // staffList = [];
    listFlows = []
    arrDoctor
    nextCountRemove
    styleModal
    statusCompliance = false
    en = {}
    showEN = true
    arrPassedDate = []
    headerTitle = ''
    clientName = ''
    statusEsc
    isShowConfirm: Boolean = false
    view: any
    thisView: any = 'aligner-create'
    arrayDate: any[] = []
    clientAlignerForm = {}

    listOption2General: any[] = []
    initData2General: any[] = []
    jsonDataSave: any = {}
    optionsStartDate: any = { format: 'YYYY.MM.DD ddd', viewMode: 'days', showTodayButton: true, useCurrent: false }
    dateReceive = ''

    arrImageHash: any[] = []
    arrImage: any[] = []
    jsonChangeDataSave = {}

    arrayShowImages: any[] = []

    isChange: any = false

    enableBehavior: any = 'false'

    styleHeight: any = {
        'top': 5.5 + 'em',
    }

    deleteImageUnsub
    getData
    header = 'header'

    constructor(private modalService: ModalService, private formBuilder: FormBuilder, private route: ActivatedRoute, private authData: AuthService, private restApi: RestServices, private _sharedService: SharedServices, private activatedRoute: ActivatedRoute,
                private stateServices: StateServices,
                public matrixServices: MatrixServices,
                private clientTopServices: ClientTopServices) {
        this.getData = modalService.changeEmitted$.subscribe(success => {
            const emitLoading = {}
            emitLoading['first'] = false
            this.stateServices.emitChangeFirstLoading(emitLoading)
            this.enableBehavior = this.stateServices.returnEnableBehavior()
            if (success.action === 'createAligner') {
                this.jsonDataSave = {}
                this.jsonChangeDataSave = {}
                this.modalAction = success.action
                this.modalStatus = 'active'
                this.activeAlignerMenu = this.alignerMenu[0]
                this.idClient = success.clientId
                this.clientDetail = success.clientDetail
                this.activeAligner = success.activeAligner
                this.arrDoctor = success.listStaff
                this.statusEsc = true
                this.callApi()
            } else if (success.action === 'updatedTreatment') {
                this.alignerTreatmentOptions[success.stageTreatmentIndex] = success.stageTreatment
                this.addTreatmentOptionKeys()
            } else if (success.action === 'initialStages') {
                this.statusEsc = true
                this.updateStages(success.flowInfo, success.flowIndex)
                if (this.activeAlignerMenu['value'] === 'general') {
                    this.activeAlignerMenu = this.alignerMenu[2]
                }
            } else if (success.action === 'editAligner') {
                this.modalAction = success.action
                this.idClient = success.clientId
                this.idAligner = success.alignerId
                this.clientDetail = success.clientDetail
                this.getAlignerInfo()
                this.activeAligner = success.activeAligner
                if (success.stageActive) {
                    this.activeAlignerMenu = this.alignerMenu[2]
                } else {
                    this.activeAlignerMenu = this.alignerMenu[0]
                }
                this.modalStatus = 'active'
                this.statusEsc = true
                // this.addTreatmentOptionKeys();
            } else if (success.action === 'removeStage') {
                this.deleteStage(success.index)
            } else if (success === 'editPaddingModal') {
                this.styleModal = { 'left': '5em', 'top': '4.5em' }
                this.statusCompliance = true
            } else if (success === 'statusESC') {
                this.statusEsc = true
            }
        })
    }

    getArrayShowImage(jsonSave) {
        const listKeys = Object.keys(jsonSave)
        listKeys.forEach(key => {
            if (typeof jsonSave[key] == 'object') {
                if (!Array.isArray(jsonSave[key])) {
                    const item = {}
                    item['key'] = key
                    if (jsonSave[key] && jsonSave[key]['matrix']) {
                        item['value'] = jQuery.extend(true, {}, jsonSave[key])
                        const findItem = this.listOption2General.find(el => {
                            return el['propertyName'] == key
                        })
                        if (findItem) {
                            item['title'] = findItem ['title']
                        } else {
                            item['title'] = ''
                        }
                        const checkAdd = this.arrayShowImages.findIndex((detailEl) => {
                            return detailEl['key'] && detailEl['key'] == key
                        })
                        const checkAll = this.listOption2General.findIndex(el => {
                            return el['propertyName'] == key
                        })
                        if (checkAdd == -1) {
                            if (checkAll != -1) {
                                this.arrayShowImages.push(item)
                            }
                        } else {
                            this.arrayShowImages[checkAdd] = item
                        }
                    }
                }
            }
        })
    }

    public getStyle() {
        if (this.modalAction == 'editAligner' || this.modalAction == 'createAligner') {
            const closeButnHeight = $('#closeButton').height()
            const actionImage = $('#action-image').height()
            const tabsListLink = $('#tabs-lists-link').height()
            const clientName = this.clientName ? $('#client-name-aligner').height() : 0
            const heightRe = actionImage + tabsListLink + clientName + 5
            this.styleHeight = {
                'top': heightRe + 'px',
            }
        }
        return this.styleHeight
    }

    functionEmitJsonSave(jsonSave: any) {
        this.jsonChangeDataSave = jsonSave
        this.isChange = true
        this.getArrayShowImage(jsonSave)
    }

    showBigImage(image) {
        const emitArr: any = {}
        emitArr['id'] = image['id']
        emitArr['showBigImage'] = true
        emitArr['matrix'] = image['matrix']
        this.clientTopServices.emitChange(emitArr)
    }

    callApi() {
        this.jsonChangeDataSave = {}
        this.jsonDataSave = {}
        this.matrixServices.arrRotate = []
        this.matrixServices.arrStyleImage = []
        this.matrixServices.arrFlip = []
        const result = '{"clientId":"' + this.idClient + '"}'
        const clientVisit: any = {}
        clientVisit[result] = true
        const map: any = {}
        map[this.idClient] = true

        const status = {
            client: {
                map: map,
            },
            clientAligner: {
                paths: clientVisit,
                searches: clientVisit,
            },
            clinic: {
                paths: {
                    '{}': true,
                },
            },
            setting: {
                map: {
                    common: true,
                },
                paths: {
                    '{}': true,
                },
            },
            staff: {
                paths: {
                    '{"roles":"cordinator"}': true,
                    '{"roles":"doctor"}': true,
                    '{}': true,
                },
            },
        }
        const resourceData = {
            actions: [],
            status: status,
        }
        this.authData.authToken().then(tokenReNew => {
            this.restApi.http_post('resource', resourceData, tokenReNew).subscribe(success => {
                const option2GeneralAll: any[] = success['response'] ? success['response']['setting']['paths']['{}'] : []
                if (option2GeneralAll && option2GeneralAll.length > 0) {
                    if (this.enableBehavior == 'true') {
                        const arraySettingOption = option2GeneralAll.find(el => {
                            return el['_id'] == 'option'
                        })
                        if (arraySettingOption) {
                            this.listOption2General = arraySettingOption['clientAlignerForm'] ? arraySettingOption['clientAlignerForm']['properties'] : []
                            const tmpJsonDataSave = {}
                            this.listOption2General.forEach(el => {
                                if (el['schema'] && el['schema']['type'] == 'date' && el['schema']['uiOptions'] && el['schema']['uiOptions']['behavior'] == 'recentToday') {
                                    tmpJsonDataSave[el['propertyName']] = moment().utc().startOf('day').valueOf()
                                }
                            })
                            this.jsonDataSave = jQuery.extend(true, {}, tmpJsonDataSave)
                            this.jsonChangeDataSave = jQuery.extend(true, {}, tmpJsonDataSave)
                        } else {
                            this.listOption2General = []
                            this.jsonDataSave = {}
                            this.jsonChangeDataSave = {}
                        }
                    } else {
                        this.listOption2General = []
                        this.jsonDataSave = {}
                        this.jsonChangeDataSave = {}
                    }
                }
            })
        })
    }

    @HostListener('document:keydown', ['$event']) handleKeyboardEvent(event: KeyboardEvent) {
        const keyPressed = event.keyCode
        const keyEnter = 13
        const keyESC = 27
        if(keyPressed === keyEnter && document.activeElement instanceof HTMLInputElement)  event.preventDefault();
        if (this.statusEsc) {
            if (keyPressed === keyESC) {
                if (this.view == this.thisView) {
                    event.preventDefault()
                    // if (this.isShowConfirm == false) {
                    const emit: any = {}
                    emit['status'] = 'show'
                    emit['view'] = 'aligner-create'
                    this._sharedService.emitChangeIsShowConfirm(emit)
                    this.changeLanguage()
                    notification.confirm({
                        message: this.en['alert-content-discard'],
                        title: '<b>' + this.en['alert-discard'] + '</b>',
                        cancelable: true,
                        buttonLabels: [this.en['alert-cancel'], 'OK'],
                        callback: i => {
                            if (i == 0) {
                                // this.statusEsc = false;
                                emit['status'] = 'hide'
                                emit['view'] = 'aligner-create'
                                this._sharedService.emitChangeIsShowConfirm(emit)
                            } else if (i === 1) {
                                this.hideModal()
                                this.statusEsc = false
                                emit['status'] = 'hide'
                                emit['view'] = 'aligner-create'
                                this._sharedService.emitChangeIsShowConfirm(emit)
                            }
                        },
                    })
                    // }
                } else if (this.view == 'client-aligner') {
                    event.preventDefault()
                    // if (this.isShowConfirm == false) {
                    const emit: any = {}
                    emit['status'] = 'show'
                    emit['view'] = 'client-aligner'
                    this._sharedService.emitChangeIsShowConfirm(emit)
                    this.changeLanguage()
                    notification.confirm({
                        message: this.en['alert-content-discard'],
                        title: '<b>' + this.en['alert-discard'] + '</b>',
                        cancelable: true,
                        buttonLabels: [this.en['alert-cancel'], 'OK'],
                        callback: i => {
                            if (i == 0) {
                                // this.statusEsc = false;
                                emit['status'] = 'hide'
                                emit['view'] = 'client-compliance'
                                this._sharedService.emitChangeIsShowConfirm(emit)
                            } else if (i === 1) {
                                this.hideModal()
                                this.statusEsc = false
                                emit['status'] = 'hide'
                                emit['view'] = 'client-compliance'
                                this._sharedService.emitChangeIsShowConfirm(emit)
                            }
                        },
                    })
                    // }
                }
            }
        }
    }

    changeMenuActive(item) {
        this.activeAlignerMenu = item
    }

    initialEmptyStages() {
        let i
        const tmpArr = []
        const arrPassedDate = []
        for (i = 0; i < this.totalNumber; i++) {
            tmpArr.push({})
            arrPassedDate.push(null)
        }
        this.clientAligner.aligners = tmpArr
        this.arrPassedDate = arrPassedDate
        this.clientAligner.aligners[0] = {
            changeDate: true,
            changeElasticTypeLeft: true,
            changeElasticTypeRight: true,
            changeInterval: true,
            changeUpdateDate: true,
            changeWearingTime: true,
        }
    }

    convertToDistinctArr(flows) {
        const tmpFlows = [].concat(flows)
        const distinctFlow = []
        tmpFlows.forEach(function(item) {
            const found = tmpFlows.find(function(e) {
                return e.nextCount == item.nextCount
            })
            if (distinctFlow.indexOf(found) === -1) {
                distinctFlow.push(found)
            }
        })
        return distinctFlow
    }

    /**
     * initialEmptyStages()
     * if !empty listFlows
     *  arrange flows by update date in Desc
     *  get distinct flows by nextCount
     *  create aligners at nextCount in flow
     */
    computeStates() {
        this.initialEmptyStages()
        let listAligners = [].concat(this.clientAligner.aligners)
        if (this.totalNumber === 0) {
            listAligners = []
        }
        this.generateTreatments()
        // initial stage at flows
        if (this.listFlows.length > 0) {
            const distinctFlow = this.convertToDistinctArr(this.listFlows)
            const abortFrom = this.clientAligner['abortedFrom']
            const totalNumber = this.totalNumber
            const arrPassedDate = this.configPassedDateScreenStage(this.listFlows)
            distinctFlow.forEach(function(e) {
                if (e.nextCount <= totalNumber) {
                    if (abortFrom && e.nextCount > abortFrom) {
                        listAligners[e.nextCount - 1] = {}
                    } else if (abortFrom && e.nextCount == abortFrom) {
                        const aligner = {
                            doctor: e.doctor, staff: e.staff, updateDate: arrPassedDate[e.nextCount - 1], abort: true,
                        }
                        listAligners[e.nextCount - 1] = omitBy(aligner, isUndefined)
                    } else {
                        const aligner = {
                            doctor: e.doctor,
                            elasticTypeLeft: e.elasticTypeLeft,
                            elasticTypeRight: e.elasticTypeRight,
                            interval: e.interval,
                            intervalUnit: e.intervalUnit,
                            staff: e.staff,
                            updateDate: arrPassedDate[e.nextCount - 1],
                            wearingTime: e.wearingTime,
                            buttoncut: e.buttoncut,
                            iprCount: e.iprCount,
                            precisioncut: e.precisioncut,
                            treatmentOptions: e.treatmentOptions,
                            changeDate: e.changeDate,
                            changeElasticTypeLeft: e.changeElasticTypeLeft,
                            changeElasticTypeRight: e.changeElasticTypeRight,
                            changeInterval: e.changeInterval,
                            changeUpdateDate: e.changeUpdateDate,
                            changeWearingTime: e.changeWearingTime,
                        }
                        if (e.nextStartDate) {
                            aligner['startDate'] = e.nextStartDate
                            const endDate = moment(aligner['startDate'])
                            .add(aligner.wearingTime, aligner.intervalUnit === 'days' ? 'days' : 'months').utc().startOf('day').valueOf()
                            aligner['endDate'] = endDate
                        }
                        listAligners[e.nextCount - 1] = omitBy(aligner, isUndefined)
                    }
                }
            })

            // create stage list
            const arrLength = this.totalNumber
            let i
            for (i = 0; i < arrLength; i++) {
                if (JSON.stringify(listAligners[i]) === '{}') {
                    const stage = {}
                    const preStage = listAligners[i - 1]
                    if (preStage['abort']) {  // if canceled stage
                        delete preStage['dateDiff']
                        delete preStage['changeDate']
                        stage['updateDate'] = this.arrPassedDate[i]
                        stage['abort'] = true
                        listAligners[i] = stage
                    } else {
                        stage['elasticTypeLeft'] = preStage.elasticTypeLeft
                        stage['elasticTypeRight'] = preStage.elasticTypeRight
                        stage['interval'] = preStage.interval
                        stage['intervalUnit'] = preStage.intervalUnit
                        stage['wearingTime'] = preStage.wearingTime
                        if (preStage.startDate) {
                            const startDate = moment(preStage.startDate)
                            .add(preStage.interval, preStage.intervalUnit === 'days' ? 'days' : 'months').utc().startOf('day').valueOf()
                            const endDate = moment(preStage.startDate)
                            .add(preStage.wearingTime, preStage.intervalUnit === 'days' ? 'days' : 'months').utc().startOf('day').valueOf()
                            stage['startDate'] = startDate
                            stage['endDate'] = endDate
                        }
                        stage['updateDate'] = this.arrPassedDate[i]
                        listAligners[i] = omitBy(stage, isUndefined)
                    }
                }
                // compute date diff
                if (i > 0 && listAligners[i - 1] && listAligners[i - 1]['startDate'] && !listAligners[i]['abort']) {
                    listAligners[i] = this.addDateDiff(listAligners[i], listAligners[i - 1])
                }
            }
        }
        this.clientAligner.lastPassedAlignerCount = this.findLastPassedAlignerCount(this.listFlows)
        this.clientAligner.aligners = listAligners
        this.activeAlignerCount = this.getActiveCount(this.clientAligner.aligners)
        this.listFlows = this.listFlows.filter(function(n) {
            return n !== ''
        })
        this.addTreatmentOptionKeys()
    }

    // config passed date flow
    configPassedDateScreenStage(listFlows) {
        const arrPassedDate = this.arrPassedDate
        const totalNumber = this.totalNumber
        listFlows.forEach(function(e) {
            if (e.nextCount <= totalNumber && e.passedAligners > 0) {
                for (let i = e.passedAlignerFrom - 1; i <= e.passedAlignerTo - 1; i++) {
                    if (arrPassedDate[i] < e.updateDate) {
                        arrPassedDate.splice(i, 1, e.updateDate)
                    }
                }
            }
        })
        return arrPassedDate
    }

    addDateDiff(currentStage, beforeStage) {
        const currentStageDate = moment(currentStage['startDate']).utc().startOf('day').toDate()
        let beforeEndDate = currentStageDate
        if (beforeStage) {
            beforeEndDate = moment(beforeStage['startDate']).add(beforeStage.interval, beforeStage.intervalUnit === 'days' ? 'days' : 'months').utc().startOf('day').toDate()
        }
        const dateDiff = Math.floor((currentStageDate.getTime() - beforeEndDate.getTime()) / 86400000)
        currentStage.dateDiff = dateDiff
        if (dateDiff !== 0) {
            currentStage.changeDate = true
        }
        return currentStage
    }

    findLastPassedAlignerCount(listFlows) {
        const flows = [].concat(listFlows)
        if (flows.length > 0) {
            const tmpFlows = flows.sort(function(a, b) {
                return b.passedAlignerTo - a.passedAlignerTo
            })
            const item = tmpFlows.find(function(e) {
                if (e.passedAlignerTo) {
                    return e
                }
            })
            if (item) {
                return item.passedAlignerTo
            }
            return 0
        }
        return 0
    }

    changeTotalNumber(numberCurent) {
        const totalNumberCurent = Number(numberCurent)
        if (totalNumberCurent > 0) {
            this.totalNumberCurent = this.totalNumber = totalNumberCurent
        } else {
            this.totalNumberCurent = this.totalNumber = 0
        }
        this.clientAligner['totalNumber'] = this.totalNumber
        this.computeStates()
    }

    generateTreatments() {
        const tmpTreatment = []
        if (this.alignerTreatmentOptions.length > this.totalNumber) {
            this.alignerTreatmentOptions = this.alignerTreatmentOptions.slice(0, this.totalNumber)
        }
        let i
        for (i = 0; i < this.totalNumber; i++) {
            if (this.alignerTreatmentOptions[i]) {
                tmpTreatment[i] = this.alignerTreatmentOptions[i]
            } else {
                tmpTreatment[i] = {}
            }
        }
        this.alignerTreatmentOptions = tmpTreatment
    }

    findAbortedFrom() {
        const distinctFlow = this.convertToDistinctArr(this.listFlows)
        distinctFlow.sort(function(a, b) {
            return a.nextCount - b.nextCount
        })
        const abortedFrom = distinctFlow.find(function(e) {
            return e.abort === true
        })
        if (abortedFrom) {
            this.clientAligner['abortedFrom'] = abortedFrom.nextCount
        } else {
            this.clientAligner['abortedFrom'] = ''
        }
    }

    updateStages(returnFlow, flowIndex) {
        const flowInfo = jQuery.extend(true, {}, returnFlow)
        if (flowIndex === -1 || flowInfo.oldStage !== flowInfo.nextCount) {
            if (flowInfo.oldStage !== flowInfo.nextCount && flowIndex !== -1) {
                this.listFlows.splice(flowIndex, 1)
            }
            this.listFlows.push(omitBy(flowInfo, isUndefined))
        } else {
            this.listFlows[flowIndex] = omitBy(flowInfo, isUndefined)
        }
        this.listFlows = this.sortFlows(this.listFlows)
        this.clientAligner.flows = this.listFlows
        this.clientAligner['updateTime'] = moment().utc().valueOf()
        this.clientAligner['endDate'] = returnFlow['endDate']
        this.findAbortedFrom()
        this.computeStates()
    }


    deleteStage(flowIndex) {
        this.listFlows.splice(flowIndex, 1)
        this.listFlows = this.sortFlows(this.listFlows)
        this.clientAligner['flows'] = this.listFlows
        this.findAbortedFrom()
        this.computeStates()
    }


    sortFlows(list) {
        if (list && !list[0]) {
            list = []
        }
        const tmpList = [].concat(list)
        tmpList.sort(function(a, b) {
            if (a.nextStartDate !== b.nextStartDate) return b.nextStartDate - a.nextStartDate
            if (a.updateDate !== b.updateDate) return b.updateDate - a.updateDate
            return b.actualUpdateDate - a.actualUpdateDate
        })
        return tmpList
    }

    findDoctor(id) {
        if (id) {
            const found = this.arrDoctor.find(function(e) {
                return e['_id'] === id
            })
            if (found) {
                found['fullName'] = (found['firstName'] || '') + ' ' + (found['familyName'] || '')
                return found
            }
        }
        return {}
    }

    createNewAligner() {
        this.clientAligner['clientId'] = this.idClient
        this.clientAligner['flows'] = this.deleteFieldOfFlows(this.clientAligner['flows'])
        this.clientAligner['isNew'] = true
        if (this.jsonChangeDataSave) {
            Object.keys(this.jsonChangeDataSave).forEach((key) => {
                this.clientAligner[key] = this.jsonChangeDataSave[key]
            })
        }
        // this.clientAligner['alignerTreatment'] = this.alignerTreatmentOptions;
        const sendAligner = {
            collection: 'clientAligner', id: null, type: 'create', value: omitBy(this.clientAligner, isUndefined),
        }
        const clientInfo = JSON.stringify({ clientId: this.idClient })
        const resourceData = {
            actions: [sendAligner], status: {
                client: {
                    map: { [this.idClient]: true },
                }, clientAligner: {
                    paths: { [clientInfo]: true }, searches: { [clientInfo]: true },
                }, clinic: {
                    paths: {
                        '{}': true,
                    },
                }, setting: {
                    map: {
                        common: true,
                    }, paths: {
                        '{}': true,
                    },
                }, staff: {
                    paths: {
                        '{"roles":"cordinator"}': true, '{"roles":"doctor"}': true, '{}': true,
                    },
                },
            },
        }

        this.authData.authToken().then(tokenReNew => {
            this.restApi.http_post('resource', resourceData, tokenReNew).subscribe(success => {
                const clientAlignerUpdated = success['response']['clientAligner']['searches']['{"clientId":"' + this.idClient + '"}']
                const listClient = success['response']['client']['map'][this.idClient]
                const data = {
                    action: 'refreshAligner', listAligner: clientAlignerUpdated, listClient: listClient,
                }
                this.jsonDataSave = {}
                this._sharedService.emitChange(data)
            })
        })
    }

    getActiveCount(alignerList) {
        const currentDate = moment().utc().startOf('day').valueOf()
        let pos = -1
        if (alignerList.length > 0) {
            alignerList.forEach(function(item, index) {
                if (item.startDate && currentDate >= item.startDate) {
                    pos = index + 1
                }
            })
        }
        if (pos > this.clientAligner.lastPassedAlignerCount) {
            pos = this.clientAligner.lastPassedAlignerCount || -1
        }
        return pos
    }

    deleteFieldOfFlows(flows) {
        if (flows && flows.length > 0) {
            flows.forEach(function(e) {
                delete e.changeDate, delete e.changeElasticTypeLeft, delete e.changeElasticTypeRight, delete e.changeInterval, delete e.changeUpdateDate, delete e.changeWearingTime, delete e.oldStage
                delete e.endDate
            })
        }
        return flows
    }

    assignAlignerInfoToFlows(flows, aligners) {
        let tmpFlows = [].concat(flows)
        tmpFlows = this.sortFlows(tmpFlows)
        const treatmentOptions = []
        if (aligners.length > 0) {
            aligners.forEach(function(e, index) {
                const info = {
                    changeDate: e.changeDate,
                    changeElasticTypeLeft: e.changeElasticTypeLeft,
                    changeElasticTypeRight: e.changeElasticTypeRight,
                    changeInterval: e.changeInterval,
                    changeUpdateDate: e.changeUpdateDate,
                    changeWearingTime: e.changeWearingTime,
                }
                const flowPos = tmpFlows.findIndex(function(flow) {
                    return flow.nextCount == (index + 1)
                })
                if (flowPos !== -1) {
                    tmpFlows[flowPos] = jQuery.extend(true, tmpFlows[flowPos], omitBy(info, isUndefined))
                }
            })
        }
        return tmpFlows
    }

    getAlignerInfo() {
        const clientInfo = JSON.stringify({ clientId: this.idClient })
        const resourceData = {
            actions: [], status: {
                client: {
                    map: { [this.idClient]: true },
                }, clientAligner: {
                    map: { [this.idAligner]: true }, paths: { [clientInfo]: true }, searches: { [clientInfo]: true },
                }, clinic: {
                    paths: {
                        '{}': true,
                    },
                }, setting: {
                    map: {
                        common: true,
                    }, paths: {
                        '{}': true,
                    },
                }, staff: {
                    paths: {
                        '{"roles":"cordinator"}': true, '{"roles":"doctor"}': true, '{}': true,
                    },
                },
            },
        }

        this.authData.authToken().then(tokenReNew => {
            this.restApi.http_post('resource', resourceData, tokenReNew).subscribe(success => {
                this.clientAligner = success['response']['clientAligner']['map'][this.idAligner]
                if (this.phaseByName[this.clientAligner['phase']]) {
                    this.activePhase = this.phaseByName[this.clientAligner['phase']]
                } else if (this.phaseNumber[this.clientAligner['phase'] - 1]) {
                    this.activePhase = this.phaseNumber[this.clientAligner['phase'] - 1]
                }
                this.totalNumber = this.clientAligner['totalNumber']
                this.arrDoctor = success['response']['staff']['paths']['{}']
                this.listFlows = this.assignAlignerInfoToFlows(this.clientAligner.flows, this.clientAligner.aligners)
                if (!this.clientAligner['isNew']) {
                    this.filterTreatmentFromAligner()
                }
                this.jsonChangeDataSave = {}
                this.alignerTreatmentOptions = this.clientAligner['alignerTreatment'] || []
                // this.addTreatmentOptionKeys();
                this.computeStates()
                this.originClientAligner = jQuery.extend(true, {}, this.clientAligner)
                const client = success['response']['client']['map'][this.idClient]                
                this.clientName = client &&  client.familyName && client.firstName ? `${client.familyName} ${client.firstName}`: ''
                this.updateHeaderTitle()
                this.initialFormData()

                const option2GeneralAll: any[] = success['response'] ? success['response']['setting']['paths']['{}'] : {}
                if (option2GeneralAll && option2GeneralAll.length > 0) {
                    if (this.enableBehavior == 'true') {
                        const arraySettingOption = option2GeneralAll.find(el => {
                            return el['_id'] == 'option'
                        })
                        if (arraySettingOption) {
                            this.listOption2General = arraySettingOption['clientAlignerForm'] ? arraySettingOption['clientAlignerForm']['properties'] : []
                        } else {
                            this.listOption2General = []
                        }
                        this.jsonDataSave = success['response']['clientAligner']['map'][this.idAligner]
                        this.jsonChangeDataSave = {}
                    } else {
                        this.listOption2General = []
                        this.jsonChangeDataSave = {}
                        this.jsonDataSave = {}
                    }

                    // const emitArrFormSetting: any = {};
                    // emitArrFormSetting['idClient'] = this.idClient;
                    // emitArrFormSetting['data'] = this.listOption2General;
                    // emitArrFormSetting['jsonDataSave'] = this.jsonDataSave;
                    // this.stateServices.emitChangeArrayFormSetting(emitArrFormSetting);
                }
                this.arrayShowImages = []
                this.getArrayShowImage(this.jsonDataSave)
            })
        })
    }

    filterTreatmentFromAligner() {
        const aligners = this.clientAligner['aligners']
        const tmpTreatment = []
        let i
        for (i = 0; i < aligners.length; i++) {
            if (aligners[i].treatmentOptions) {
                const treatment = {
                    treatmentOptions: aligners[i].treatmentOptions,
                    buttoncut: aligners[i].buttoncut,
                    precisioncut: aligners[i].precisioncut,
                    iprCount: aligners[i].iprCount,
                    treatment: aligners[i].treatment,
                }
                tmpTreatment[i] = omitBy(treatment, isUndefined)
            } else {
                tmpTreatment[i] = {}
            }
        }
        this.clientAligner['alignerTreatment'] = tmpTreatment
    }

    ngOnInit() {
        this.stateServices.emitChangeViewAligner('renderData')
        this.initialForm()
        this.deleteImage()

        this._sharedService.changeEmittedIsShowConfirm$.subscribe(confirm => {
            if (confirm != null && confirm != undefined && confirm['status'] != undefined) {
                if (confirm['status'] == 'show') {
                    this.isShowConfirm = true
                    this.view = confirm['view']
                } else {
                    this.isShowConfirm = false
                    this.view = confirm['view']
                }
            }
        })
    }

    ngOnDestroy() {
        if(this.deleteImageUnsub)
            this.deleteImageUnsub.unsubscribe()
        if(this.getData)
            this.getData.unsubscribe()
    }

    deleteImage() {
        this.deleteImageUnsub = this.stateServices.changeEmittedDeletePropertyName$.subscribe(res => {
            if (res) {
                const findItem = this.arrayShowImages.findIndex(el => {
                    return el['key'] == res['propertyName']
                })
                if (findItem != -1) {
                    this.arrayShowImages.splice(findItem, 1)
                }
                this.stateServices.emitChangeDeletePropertyName(null)
            }
        })
    }

    changeLanguage() {
        return this.en = this.authData.showLang(this.showEN)
    }

    initialForm() {
        this.formNewAlignerGeneral = this.formBuilder.group({
            'title': [''], 'totalNumber': [''],
        })
    }

    initialFormData() {
        this.formNewAlignerGeneral.patchValue({
            title: this.clientAligner['title'], totalNumber: this.clientAligner['totalNumber'],
        })
    }

    hideModal() {
        this.matrixServices.resetMatrix()
        this.stateServices.emitChangeViewAligner('searchData')
        const emitLoading = {}
        emitLoading['first'] = false
        this.stateServices.emitChangeFirstLoading(emitLoading)
        this.jsonChangeDataSave = {}
        this.jsonDataSave = {}
        const emitCloseActiveAligner: any = {}
        emitCloseActiveAligner['reset-value'] = true
        this.stateServices.emitChangeResetValueMatrix(emitCloseActiveAligner)
        this.arrayShowImages = []
        this.modalStatus = 'hidden'
        this.totalNumber = 0
        this.activePhase = {}
        // this.idClient = null;
        this.idAligner = null
        this.clientAligner = {
            lastPassedAlignerCount: 0, aligners: [], flows: [], alignerTreatment: [], totalNumber: 0,
        }
        this.originClientAligner = jQuery.extend(true, {}, this.clientAligner)
        this.alignerTreatmentOptions = []
        this.clientDetail = {}
        this.activeAlignerCount = 0
        this.modalAction = ''
        this.listFlows = []
        this.initialForm()
        this.statusCompliance = false
        this.styleModal = { 'left': '2.5em', 'top': '2.5em' }
        this.activeAligner = {}
        this.headerTitle = ''
    }

    discardModal(action) {
        this.changeLanguage()
        this.clientAligner['alignerTreatment'] = this.alignerTreatmentOptions
        const showConfirm = JSON.stringify(this.clientAligner) !== JSON.stringify(this.originClientAligner) ? true : false
        if ((showConfirm && action === 'close') || (action === 'close' && this.isChange)) {
            notification.confirm({
                message: this.en['alert-content-discard'],
                title: this.en['alert-discard'],
                cancelable: true,
                buttonLabels: [this.en['alert-cancel'], 'OK'],
                callback: i => {
                    if (i === 1) {
                        this.hideModal()
                    }
                },
            })
        } else if ((showConfirm && action === 'save') || (action === 'save' && this.isChange)) {
            notification.confirm({
                message: this.en['alert-content-save'],
                title: this.en['alert-save'],
                cancelable: true,
                buttonLabels: [this.en['alert-cancel'], 'OK'],
                callback: i => {
                    if (i === 1) {
                        this.save()
                    }
                },
            })
        } else {
            this.hideModal()
        }
    }

    save() {
        if (this.modalAction === 'createAligner') {
            this.createNewAligner()
        } else if (this.modalAction === 'editAligner') {
            this.updateAligner()
        }
        this.hideModal()
    }

    prevRatio(totalNumberCurent, day) {
        if ((parseInt(totalNumberCurent) - parseInt(day)) > 0) {
            this.totalNumber = parseInt(totalNumberCurent) - parseInt(day)
        } else {
            this.totalNumber = 0
        }
    }

    nextRatio(totalNumberCurent, day) {
        if (parseInt(totalNumberCurent) < 200) {
            this.totalNumber = parseInt(totalNumberCurent) + parseInt(day)
        } else {
            this.totalNumber = 200
        }
    }

    changeActivePhase(phase) {
        this.activePhase = phase
        this.clientAligner['phase'] = phase.value
        this.updateHeaderTitle()
    }

    changeTitle(title) {
        this.clientAligner['title'] = title
        this.updateHeaderTitle()
    }

    updateHeaderTitle() {
        const phase = this.activePhase['name'] || ''
        const title = this.clientAligner['title'] || ''
        let fullTitle = phase + ' ' + title
        fullTitle = fullTitle.trim()
        if (phase || title) {
            this.headerTitle = '(' + fullTitle + ')'
        } else {
            this.headerTitle = ''
        }
    }

    addTreatmentOptionKeys() {
        if (this.alignerTreatmentOptions.length > 0) {
            this.alignerTreatmentOptions.forEach(function(item) {
                if (item.treatmentOptions) {
                    const options = jQuery.extend(true, {}, item.treatmentOptions)
                    delete options['ipr']
                    delete options['buttoncut']
                    delete options['precisioncut']
                    item['treatmentOptionKeys'] = Object.keys(options)
                }
            })
        }
    }

    removeAlignerConfirm() {
        this.changeLanguage()
        notification.confirm({
            message: this.en['alert-content-2'],
            title: this.en['alert-remove'],
            cancelable: true,
            buttonLabels: [this.en['alert-cancel'], 'OK'],
            callback: i => {
                if (i === 1) {
                    this.removeAligner()
                }
            },
        })
    }

    removeAligner() {
        const clientInfo = JSON.stringify({ clientId: this.idClient })
        const resourceData = {
            actions: [{
                collection: 'clientAligner', id: this.idAligner, type: 'remove',
            }], status: {
                client: {
                    map: { [this.idClient]: true },
                }, clientAligner: {
                    paths: { [clientInfo]: true }, searches: { [clientInfo]: true },
                }, clinic: {
                    paths: {
                        '{}': true,
                    },
                }, setting: {
                    map: {
                        common: true,
                    }, paths: {
                        '{}': true,
                    },
                }, staff: {
                    paths: {
                        '{"roles":"cordinator"}': true, '{"roles":"doctor"}': true, '{}': true,
                    },
                },
            },
        }

        this.authData.authToken().then(tokenReNew => {
            this.restApi.http_post('resource', resourceData, tokenReNew).subscribe(success => {
                const clientAlignerUpdated = success['response']['clientAligner']['searches']['{"clientId":"' + this.idClient + '"}']
                const listClient = success['response']['client']['map'][this.idClient]
                const data = {
                    action: 'removeAligner', listAligner: clientAlignerUpdated, listClient: listClient,
                }
                this._sharedService.emitChange(data)
                this.stateServices.emitChangeRefreshAligner('refresh')
                this.hideModal()
            })
        })
    }

    updateAligner() {
        const clientInfo = JSON.stringify({ clientId: this.idClient })
        delete this.clientAligner['_id']
        this.clientAligner['flows'] = this.deleteFieldOfFlows(this.clientAligner['flows'])
        this.clientAligner['isNew'] = true
        if (this.jsonChangeDataSave) {
            Object.keys(this.jsonChangeDataSave).forEach((key) => {
                if (key != 'aligners' && key != 'alignerTreatment' && key != 'clientId' && key != 'createTime' && key != 'flows' && key != 'isNew' && key != 'lastPassedAlignerCount' && key != 'title' && key != 'updateTime' && key != '_id' && key != 'totalNumber') {
                    this.clientAligner[key] = this.jsonChangeDataSave[key]
                }
            })
        }
        const emitUpdate = {}
        emitUpdate['update'] = this.clientAligner
        // this.clientAligner['alignerTreatment'] = this.alignerTreatmentOptions;
        const resourceData = this.restApi.makeResourceObject({
            actions: [{
                collection: 'clientAligner', id: this.idAligner, type: 'update', value: this.clientAligner,
            }],
            status: {
                client: {
                    map: { [this.idClient]: true },
                },
                clientAligner: {
                    map: { [this.idAligner]: true }, paths: { [clientInfo]: true }, searches: { [clientInfo]: true },
                },
            },
        })

        this.authData.authToken().then(tokenReNew => {
            this.restApi.http_post('resource', resourceData, tokenReNew).subscribe(success => {
                const clientAlignerUpdated = success['response']['clientAligner']['searches']['{"clientId":"' + this.idClient + '"}']
                const listClient = success['response']['client']['map'][this.idClient]
                const data = {
                    action: 'refreshAligner', listAligner: clientAlignerUpdated, listClient: listClient,
                }
                this._sharedService.emitChange(data)
                this.stateServices.emitChangeUpdateAligner(emitUpdate)
            })
        })
    }


    //************************************************** TREATMENT **************************************************************************//
    editTreatment(index) {
        let treatment = {}
        if (this.alignerTreatmentOptions[index]) {
            treatment = this.alignerTreatmentOptions[index]
        }
        const arrTreatment = {
            action: 'modalTreatmentActive',
            stageTreatment: treatment,
            stageTreatmentIndex: index,
            treatmentOptions: Object.values(this.treatmentOptions),
            totalNumber: this.totalNumber,
        }
        this._sharedService.emitChange(arrTreatment)
    }

    //************************************************** ADJUSTMENT **************************************************************************//
    editFlow(action, index, flow) {
        let sentFlow = {}
        if (action === 'newFlow') {
            const currentDate = moment().utc().startOf('day').valueOf()
            sentFlow = {
                debug: action,
                updateDate: currentDate,
                nextStartDate: currentDate,
                nextCount: 1,
                lastPassedAlignerCount: 0,
                lastPassedAlignerNext: 1,
                passedAlignerFrom: 1,
                passedAligners: 0,
                totalNumber: Number(this.totalNumber),
                wearingTime: 20,
                interval: 7,
                intervalUnit: 'days',
                oldStage: 1,
                changeDate: true,
                changeElasticTypeLeft: true,
                changeElasticTypeRight: true,
                changeInterval: true,
                changeUpdateDate: true,
                changeWearingTime: true,
            }
        } else {
            flow.oldStage = flow.nextCount
            sentFlow = omitBy(flow, isUndefined)
            sentFlow['debug'] = action
        }
        sentFlow['lastPassedAlignerCount'] = this.clientAligner.lastPassedAlignerCount
        sentFlow['lastPassedAlignerNext'] = sentFlow['lastPassedAlignerCount'] + 1
        sentFlow['actualUpdateDate'] = moment().utc().valueOf()
        sentFlow['totalNumber'] = Number(this.totalNumber)
        const arrFlow = {
            action: 'activeAdjustment', sentFlow: sentFlow, indexFlow: index,
        }
        this._sharedService.emitChange(arrFlow)
        if (this.statusCompliance === true) {
            this._sharedService.emitChange('editPaddingModalAdjustment')
        }
        this.statusEsc = false
    }

    editFlowByStage(index, stage) {
        if (index <= this.clientAligner.lastPassedAlignerCount) {
            const distinctFlow = this.convertToDistinctArr(this.listFlows)
            // find according flow
            const found = distinctFlow.find(function(e) {
                return e.nextCount == (index + 1)
            })
            let sentFlow = {}
            let flowIndex = -1
            if (found) {
                sentFlow = found
                flowIndex = this.listFlows.indexOf(found)
            } else {
                const currentDate = moment().utc().startOf('day').valueOf()
                sentFlow = {
                    abort: stage.abort,
                    updateDate: currentDate,
                    nextStartDate: stage.startDate,
                    nextCount: index + 1,
                    oldStage: index + 1,
                    interval: stage.interval || 7,
                    wearingTime: stage.wearingTime || 20,
                    intervalUnit: stage.intervalUnit || 'days',
                    elasticTypeLeft: stage.elasticTypeLeft,
                    elasticTypeRight: stage.elasticTypeRight,
                    changeDate: stage.changeDate,
                    totalNumber: Number(this.totalNumber),
                    lastPassedAlignerCount: this.clientAligner.lastPassedAlignerCount,
                    lastPassedAlignerNext: this.clientAligner.lastPassedAlignerCount + 1,
                    passedAlignerFrom: this.clientAligner.lastPassedAlignerCount + 1,
                    passedAligners: 0,
                }
                if (!stage.startDate) {
                    sentFlow['nextStartDate'] = currentDate
                }
                if (index === 0) {
                    sentFlow['changeDate'] = true
                    sentFlow['changeElasticTypeLeft'] = true
                    sentFlow['changeElasticTypeRight'] = true
                    sentFlow['changeInterval'] = true
                    sentFlow['changeUpdateDate'] = true
                    sentFlow['changeWearingTime'] = true
                }
            }
            this.editFlow('byAligner', flowIndex, sentFlow)
        }
    }

    /**
     * nextCount = activeAlignerCount
     * if no activeAlignerCount
     *  nextCount = 1
     *  found = corresponding flow
     *  foundIndex = corresponding flow index
     *  if found
     *    editFlow(editFlow, foundIndex, found)
     *  else
     *    find stage at nextCount - 1
     *    editFlowByStage(nextCount - 1, stage)
     */
    editActiveStage() {
        let nextCount = this.activeAlignerCount
        if (nextCount == -1) {
            nextCount = 1
        }
        const found = this.listFlows.find(function(e) {
            return e.nextCount == nextCount
        })
        if (found) {
            const currentDate = moment().utc().startOf('day').valueOf()
            const sentFlow = jQuery.extend(true, {}, found)
            sentFlow['updateDate'] = currentDate
            sentFlow['nextStartDate'] = currentDate
            sentFlow['lastPassedAlignerCount'] = this.clientAligner.lastPassedAlignerCount
            sentFlow['lastPassedAlignerNext'] = this.clientAligner.lastPassedAlignerCount + 1
            sentFlow['passedAlignerFrom'] = this.clientAligner.lastPassedAlignerCount + 1
            sentFlow['passedAligners'] = 0
            delete sentFlow['doctor']
            delete sentFlow['staff']
            delete sentFlow['remark']
            this.editFlow('editFlow', -1, sentFlow)
        } else {
            const stage = this.clientAligner.aligners[nextCount - 1]
            this.editFlowByStage(nextCount - 1, stage)
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/app_manager/modal/client-detail/aligner/aligner-create/aligner-create.component.ts